module.exports = __webpack_public_path__ + "static/img/service_introduce_5120_zh.efe256f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5120_zh.png
// module id = ShID
// module chunks = 34